const DARK = "#1c1c1c";
const LIGHT = "#fdf4ee";

function parseColor(value) {
  const probe = document.createElement("span");
  probe.style.color = value;
  document.body.appendChild(probe);
  const match = getComputedStyle(probe).color.match(/[\d.]+/g);
  probe.remove();
  return match ? match.slice(0, 3).map(Number) : null;
}

function luminance(rgb) {
  const channels = rgb.map(value => {
    const channel = value / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}

function contrastRatio(first, second) {
  const lighter = Math.max(first, second);
  const darker = Math.min(first, second);
  return (lighter + 0.05) / (darker + 0.05);
}

export function getAccessibleContrastColor(background) {
  const rgb = parseColor(background);
  if (!rgb) return DARK;

  const backgroundLuminance = luminance(rgb);
  const darkContrast = contrastRatio(backgroundLuminance, luminance([28, 28, 28]));
  const lightContrast = contrastRatio(backgroundLuminance, luminance([253, 244, 238]));
  return darkContrast >= lightContrast ? DARK : LIGHT;
}

function setEditionContrast(section) {
  const accent = getComputedStyle(section).getPropertyValue("--tag-accent-color").trim();
  const background = section.classList.contains("edition-item--current") ? LIGHT : (accent || LIGHT);
  section.style.setProperty("--edition-contrast-color", getAccessibleContrastColor(background));
  section.style.setProperty("--edition-accent-contrast-color", getAccessibleContrastColor(accent || LIGHT));
}

function initRail(section) {
  const rail = section.querySelector(".edition-triple-grid");
  if (!rail) return;

  const previous = section.querySelector('[data-edition-rail="previous"]');
  const next = section.querySelector('[data-edition-rail="next"]');
  const updateControls = () => {
    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    previous.disabled = rail.scrollLeft <= 1;
    next.disabled = rail.scrollLeft >= maxScroll - 1;
  };

  [previous, next].forEach(button => {
    button.addEventListener("click", () => {
      const direction = button.dataset.editionRail === "previous" ? -1 : 1;
      rail.scrollBy({ left: direction * rail.clientWidth * 0.72, behavior: "smooth" });
    });
  });

  rail.addEventListener("scroll", updateControls, { passive: true });
  window.addEventListener("resize", updateControls);
  updateControls();
}

function initShare(button) {
  button.addEventListener("click", async () => {
    const url = button.dataset.shareUrl;
    const title = button.dataset.shareTitle || document.title;
    if (navigator.share) {
      await navigator.share({ title, url });
      return;
    }
    await navigator.clipboard?.writeText(url);
    button.textContent = "Copied";
    window.setTimeout(() => { button.textContent = "Share"; }, 1600);
  });
}

export default function initEditions(root = document) {
  root.querySelectorAll("[data-edition-color]").forEach(section => {
    if (section.dataset.editionReady === "true") return;
    section.dataset.editionReady = "true";
    setEditionContrast(section);
    initRail(section);
    section.querySelectorAll("[data-edition-share]").forEach(initShare);
  });
}
